import React from "react";
import { Carousel } from "react-responsive-carousel";
import "./App.css";


export default () => (
          <Carousel autoPlay>
                <div carousel="carousel">
                    <img src={require("./images/Sepa-home.PNG")} />
                    {/* <p className="legend">System Engineering Program Application (SEPA) is to give WRPS Cognizant System Engineers a tool to provide a status report (SystemHealth) for their specific systems (e.g., HVAC, 242-A Evaporator, etc.), provided from multiple other operational sources of data. Reports can be generated into one summary graphic for all systems, which include the status of issue resolution for all issues related to system health.</p> */}
                </div>

                <div className="carousel">
                    <img src={require('./images/CodersConnect.JPG')}/>
                    {/* <p className="legend">Developer Networking application built with a MERN Stack (MongoDB, ExpressJS, NodeJS, and React). Redux was used. Authentication is implemented with JWToken, Passport, and Bcrypt. Grvatars are automatically pulled in from the users email accouont. And the Github API was employed to pull in portfolio projects.</p> */}
                </div>
                <div className="carousel">
                    <img src={require('./images/RezRight.PNG')}/>
                    {/* <p className="legend">Resume Builder, created with my team at Lambda Coding Academy, built on a MERN Stack. JWS Authentication was used. Stripe was used for taking credit card payments for memberships, and a print to PDF function was implemented.</p> */}
                </div>
                <div className="carousel">
                    <img src={require("./images/pj28.png" )}/>
                    {/* <p className="legend">Business management application built with Django and AWS Cloud Services. Django includes the ability to easily implement an admin section and authentication.</p> */}
                </div>
            </Carousel>
        );



// WEBPACK FOOTER //
// ./src/responsive-carousel.js